module.exports = __webpack_public_path__ + "img/new_shujifengmian.47ff0aab.png";